module.exports = __webpack_public_path__ + "static/media/telefono.36a92867.svg";